import WSService from "../../web-socket/web-socket-service";
import callApi, { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { CHAT_TYPE } from "../varibles/constants";

const urlBase = urlServer + '/chat';

interface IGetChats {
    index: number
}

export function getChatsFetch(body: IGetChats) {
    return callApi(urlBase + 's', {
        method: "POST",
        body: JSON.stringify(body)
    })
}

interface IGetChatsOperation {
    index: number
}

export function getChatsOperationFetch(body: IGetChatsOperation) {
    return callApi(urlBase + 's/operation', {
        method: "POST",
        body: JSON.stringify(body)
    })
}

interface IUpdateChat {
    id: string
    name: string
}

export function updateChatFetch(body: IUpdateChat) {
    return callApi(urlBase, {
        method: "PUT",
        body: JSON.stringify(body)
    })
}

interface IUpdateMessage {
    group_id: string,
    chat_id: string,
    message: string,
}

export function updateMessageFetch(body: IUpdateMessage) {
    return callApi(urlBase + '/message', {
        method: "PUT",
        body: JSON.stringify({
            ...body,
            connection_id: WSService.getConnectId()
        })
    })
}

interface IGetMessages {
    id: string
    index: number
}

export function getMessagesFetch(body: IGetMessages) {
    return callApi(urlBase + '/messages', {
        method: "POST",
        body: JSON.stringify(body)
    })
}

export function readAllMessageFetch() {
    return callApi(urlBase + '/reads', {
        method: "PUT",
    })
}

interface ISeenMessage {
    id: string
    chat_id: string
    username: string
    timestamp: number
    connection_id: string,
}

export function seenMessageFetch(body: ISeenMessage) {
    return callApi(urlBase + '/seen', {
        method: "PUT",
        body: JSON.stringify(body)
    })
}

interface IAddUsersToChat {
    id: string
    users: string[]
    members: any[]
    user_tenant_name: string,
    message: string,
    timestamp: number,
    username: string,
    connection_id: string,
}

export function addUsersToChatFetch(body: IAddUsersToChat) {
    return callApi(urlBase + '/user', {
        method: "PUT",
        body: JSON.stringify(body)
    })
}

interface IRemoveUsersFromChat {
    id: string
    users: string[]
    members: any[]
    user_tenant_name: string,
    message: string,
    timestamp: number,
    username: string,
    connection_id: string,
}

export function removeUsersFromChatFetch(body: IRemoveUsersFromChat) {
    return callApi(urlBase + '/user', {
        method: "DELETE",
        body: JSON.stringify(body)
    })
}

interface ICloseConversation {
    connection_id: string
}

export function closeConversationFetch(chatId: string, body: ICloseConversation) {
    return callApi(urlBase + '/' + chatId, {
        method: "DELETE",
        body: JSON.stringify(body)
    })
}

interface ISearchConversation {
    key: string
    index: number
}

interface ISendMessage {
    group_id: string,
    user_tenant_name: string,
    message: string,
    timestamp: number,
    username: string,
    roles: string[]
    tenant_id?: string
}

interface ICreateChat {
    name: string
    users: string[]
    members: any[]
    user_tenant_name: string
    timestamp: number
    username: string
    type: CHAT_TYPE
    roles: string[]
}

export function createChatFetch(body: ICreateChat) {
    return callApi(urlBase, {
        method: "POST",
        body: JSON.stringify(body)
    })
}


export const ChatService = {
    searchUser: (body: ISearchConversation, abort?: AbortController) => api.post(urlBase + '/user', body, { signal: abort?.signal }),
    searchOp: (body: ISearchConversation, abort?: AbortController) => api.post(urlBase + '/operation', body, { signal: abort?.signal }),
    createChat: (body: ICreateChat) => {
        const connection_id = WSService.getConnectId();
        return api.post(urlBase, { ...body, connection_id })
    },
    sendMessage: (body: ISendMessage) => {
        const connection_id = WSService.getConnectId();
        return api.post(urlBase + '/message', { ...body, connection_id })
    },
}